// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading_box .loading_mask[data-v-575da6a6]{position:fixed;top:0;left:0;right:0;bottom:0;z-index:5000}.loading_box .loading_toast[data-v-575da6a6]{position:fixed;top:50%;left:50%;width:110px;height:110px;transform:translateX(-50%) translateY(-50%);border-radius:5px;background:rgba(0,0,0,.8);text-align:center;padding-top:25px;box-sizing:border-box;font-size:18px;z-index:5001}.loading_box .loading_toast .loading_content[data-v-575da6a6]{color:#fff;margin-top:15px;font-size:16px}", ""]);
// Exports
module.exports = exports;
